var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 18.715V70c0 5.523-4.477 10-10 10H49.123c-11.731-5.47-16.867-17.202-17.581-28.366a26.138 26.138 0 01-.108-2.057c.027-.34.04-.68.055-1.029.013-.334.026-.674.053-1.028C32.516 32.288 41.72 16 64.677 16h.758c5.665 0 10.492.992 14.565 2.715z",
    fill: "#88D6AD",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dHouse)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 51H24v19h47V51z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 51.999l5.137-20h41.027l3.836 20H22z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 33.999H35v11h25v-11z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.867 24L33 36h29l-2.285-12H36.867z",
    fill: "#88D6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.728 55.446h-7.312v13.55h7.312v-13.55zm11.482.768h-3.566v3.515h3.566v-3.515zm4.771 0h-3.565v3.515h3.565v-3.515zm-4.771 4.792h-3.566v3.643h3.566v-3.643zm4.771 0h-3.565v3.643h3.565v-3.643zM52.222 36.804h-2.79v2.752h2.79v-2.752zm3.736 0h-2.79v2.752h2.79v-2.752zm-3.736 3.752h-2.79v2.851h2.79v-2.85zm3.736 0h-2.79v2.851h2.79v-2.85zM41.83 36.804h-2.79v2.752h2.79v-2.752zm3.734 0h-2.79v2.752h2.79v-2.752zm-3.734 3.752h-2.79v2.851h2.79v-2.85zm3.734 0h-2.79v2.851h2.79v-2.85z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.802 56.818h-1.757v1.732h1.757v-1.732zm2.355 0H44.4v1.732h1.757v-1.732zm-2.355 2.363h-1.757v1.796h1.757V59.18zm2.355 0H44.4v1.796h1.757V59.18zm.603 4.511a.498.498 0 00.484-.512.498.498 0 00-.483-.51.498.498 0 00-.484.51c0 .283.217.512.484.512z",
    fill: "#F5F4F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dHouse",
    x: 21,
    y: 22,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.10c49d86fa843bf01647b5e3d877fa69.svg";
export { ForwardRef as ReactComponent };